import React from 'react'
import { Field } from 'redux-form'
import { Checkbox } from 'semantic-ui-react'

class FieldComponent extends React.Component {
  handleChange = (e, { checked }) => {
    this.props.input.onChange(!checked)

    if (this.props.customCheckBoxOnChange) this.props.customCheckBoxOnChange(checked)
  }

  componentDidMount() {
    if (this.props.checkboxDisabledByDefault === true && this.props.checkboxDisabled === undefined) {
      this.handleChange(undefined, { checked: false })
    }
  }

  render() {
    const {
      input: { value },
      label,
      disabled,
    } = this.props

    return <Checkbox checked={!value} onChange={this.handleChange} label={label} disabled={disabled} />
  }
}

const DisabilityCheckboxField = (props) => <Field {...props} component={FieldComponent} />

export default DisabilityCheckboxField
